import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const ORDERS_ADMIN = gql`
  query OrdersAdmin($filter: OrderFilter, $sort: OrderSort) {
    ordersAdmin(filter: $filter, sort: $sort) {
      count
      data {
        isPreOrder
        isDelayed
        totalOrdersCount
        isFirstOrder
        delayedInConfirmed
        delayedInShipped
        expectedDeliveryDate
        metadata
        statusHistory {
          newStatus
          oldStatus
          createdAt
        }
        deliveryAttachments {
          url
          key
          deliveryAttachmentsType
        }
        orderNumber
        partnerOrderId
        id
        deliveryType
        orderType
        orderItemCount
        cancelledBy
        note
        deliveredOn
        deliveryPartner {
          id
          userNumber
          firstName
          lastName
          latLong {
            coordinates
          }
        }
        user {
          id
          userNumber
          firstName
          lastName
          pincode {
            pincode
          }
        }
        library {
          city
          name
          id
          libraryNumber
        }
        createdAt
        status
        cancellationData {
          date
          additionalComment
          reason
          type
        }
        comment {
          isResolved
          comment
        }
        currentStatusTime
        nextStatusTime
        isExpressDelivery
        isQuickDelivery
        orderTags
        scheduledOrders {
          id
          orderNumber
        }
      }
      configs {
        id
        key
        type
        value
      }
    }
  }
`;

export const ORDER_ITEMS_ADMIN = gql`
  query OrderItemsAdmin($where: OrderUniqueInput) {
    orderItemsAdmin(where: $where) {
      count

      data {
        picker {
          id
          firstName
          lastName
          userNumber
        }
        packer {
          id
          firstName
          lastName
          userNumber
        }
        inventoryUnits {
          id
          qrCode
          unitCode
          status
          shelfLocation
          rack {
            id
            name
          }
        }
        isPreOrder
        stockAtBooking
        libraryInventory {
          id
          availableStock
          physicallyAvailableStock
          pendingDispatchCount
        }
        order {
          orderNumber
        }
        id
        returnDate
        adminNote
        transferOrders {
          status
        }
        contentHistory {
          id
          newContent {
            id
            quantity
            value
          }
          oldContent {
            id
            quantity
            value
          }
          status
          createdAt
        }
        deliveryConfirmationData {
          confirmedAt
          type
        }
        statusHistory {
          newStatus
          oldStatus
          createdAt
        }
        comment {
          isResolved
          comment
        }
        cancellationData {
          additionalComment
          date
          reason
          type
        }
        toy {
          id
          toyNumber
          name
          ageGroups {
            id
            minAge
            maxAge
          }
          brand {
            id
            name
          }
          bag {
            id
            name
            size
            image
          }
          images {
            contentType
            key
            order
            size
            url
          }
        }
        status
      }
    }
  }
`;

export const RETURN_ORDERS_ADMIN = gql`
  query returnOrdersAdmin(
    $filter: ReturnOrderItemFilter
    $sort: ReturnOrderSort
  ) {
    returnOrdersAdmin(filter: $filter, sort: $sort) {
      count
      returnRequestedOrderCount
      data {
        id
        status
        toyCondition
        inventoryUnits {
          id
          qrCode
          unitCode
          status
          shelfLocation
          rack {
            id
            name
          }
        }
        contentHistory {
          id
          newContent {
            id
            quantity
            value
          }
          oldContent {
            id
            quantity
            value
          }
          status
          createdAt
        }
        statusHistory {
          newStatus
          oldStatus
          createdAt
        }
        deliveryAttachments {
          url
          key
          deliveryAttachmentsType
        }
        productRate
        videoUrl
        images {
          key
          url
        }
        orderItem {
          toy {
            type
            ageGroups {
              id
              minAge
              maxAge
            }
            brand {
              id
              name
            }
            bag {
              id
              name
              size
              image
            }
            images {
              contentType
              key
              order
              size
              url
            }
            name
            id
            toyNumber
          }
        }
        order {
          id
          orderNumber
          deliveryType
        }
        libraryInventory {
          id
          library {
            name
            libraryNumber
          }
        }
        returnOrder {
          metadata
          id
          returnOrderNumber
          partnerOrderId
          statusHistory {
            newStatus
            oldStatus
            createdAt
          }
          library {
            id
            name
            libraryNumber
          }
          statusHistory {
            newStatus
            oldStatus
            createdAt
          }
          receiverLibrary {
            id
            name
            libraryNumber
          }
          user {
            firstName
            lastName
            userNumber
            id
            pincode {
              pincode
            }
          }
          deliveryPartner {
            firstName
            lastName
            userNumber
            id
            metaData
          }
          orderTags
        }
        createdAt
        returnedOn
      }
    }
  }
`;

export const ORDERS_SELECT = gql`
  query OrdersAdmin($filter: OrderFilter, $sort: OrderSort) {
    ordersAdmin(filter: $filter, sort: $sort) {
      count
      data {
        orderNumber
        id
      }
    }
  }
`;

export const RETURN_ORDERS_ADMIN_SELECT = gql`
  query returnOrdersAdmin(
    $filter: ReturnOrderItemFilter
    $sort: ReturnOrderSort
  ) {
    returnOrdersAdmin(filter: $filter, sort: $sort) {
      count
      data {
        returnOrder {
          id
          returnOrderNumber
        }
      }
    }
  }
`;

export const GET_READY_TO_SHIP_ORDERS = gql`
  query getReadyToShipOrder($where: GetReadyToShipOrderInput!) {
    getReadyToShipOrder(where: $where) {
      deliveryPartner {
        id
        userNumber
        firstName
        lastName
      }
      returnOrderCount
      orderItemCount
    }
  }
`;

export const TOYS = gql`
  query Toys($filter: ToysFilter, $sort: ToysSort) {
    toys(filter: $filter, sort: $sort) {
      data {
        id
        name
      }
      count
    }
  }
`;

export const GET_ORDER_CHALLAN_DOWNLOAD_URL_ADMIN = gql`
  query GetOrderChallanDownloadUrlAdmin($where: OrderUniqueInput!, $orderIds: [ID]) {
    getOrderChallanDownloadUrlAdmin(where: $where, orderIds: $orderIds) {
      challanUrl
    }
  }
`;

export const GET_ORDER_STICKER_DOWNLOAD_URL_ADMIN = gql`
  query GetOrderStickerDownloadUrlAdmin($where: OrderItemUniqueInput!) {
    getOrderStickerDownloadUrlAdmin(where: $where) {
      stickerUrl
    }
  }
`;
